var render, staticRenderFns
import script from "./ChartPolicyViolationsClassification.vue?vue&type=script&lang=js&"
export * from "./ChartPolicyViolationsClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b34fff')) {
      api.createRecord('41b34fff', component.options)
    } else {
      api.reload('41b34fff', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/ChartPolicyViolationsClassification.vue"
export default component.exports